(() => {
  'use strict';

  /**
   * Corrige a perda/nota incompleta do carrinho: o componente <cart-note> só
   * grava a nota no "blur" do textarea (com debounce de 500ms), mas o botão
   * de checkout ('button#checkout', name="checkout") é um submit nativo do
   * form ('CartPageForm' / 'CartDrawerForm'). Ao clicar em checkout logo a
   * seguir a escrever a nota, a navegação para o checkout pode começar antes
   * do pedido fetch da nota sequer arrancar, perdendo-a total ou parcialmente.
   *
   * Este script intercepta o submit desses forms e garante que a nota atual
   * do textarea é gravada no carrinho ANTES de deixar o checkout prosseguir.
   */

  const CHECKOUT_FORM_IDS = ['CartPageForm', 'CartDrawerForm'];
  const NOTE_TEXTAREA_SELECTOR = '.cart-note__textarea';
  const FLUSHED_FLAG = '__cartNoteFlushed';

  function getCartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function findUnsavedNoteTextarea() {
    const textareas = document.querySelectorAll(NOTE_TEXTAREA_SELECTOR);
    for (const textarea of textareas) {
      if (textarea.value !== textarea.defaultValue) return textarea;
    }
    return null;
  }

  function saveNote(value) {
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note: value }),
    }).catch((error) => {
      console.error('[cart-note-checkout-fix] falha ao gravar a nota antes do checkout', error);
    });
  }

  function handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !CHECKOUT_FORM_IDS.includes(form.id)) return;

    if (form[FLUSHED_FLAG]) {
      form[FLUSHED_FLAG] = false;
      return;
    }

    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    const textarea = findUnsavedNoteTextarea();
    if (!textarea) return;

    event.preventDefault();

    saveNote(textarea.value).then(() => {
      form[FLUSHED_FLAG] = true;
      if (form.requestSubmit) {
        form.requestSubmit(submitter);
      } else {
        submitter.click();
      }
    });
  }

  document.addEventListener('submit', handleSubmit, true);
})();
